/**
 * Mobile bottom nav — search/cart triggers + live cart badge sync.
 */
(function () {
  var nav = document.querySelector('[data-snt-bottom-nav]');
  if (!nav) return;

  var badge = nav.querySelector('[data-snt-bottom-cart-count]');
  var cartBtn = nav.querySelector('[data-snt-bottom-cart]');
  var searchBtn = nav.querySelector('[data-snt-bottom-search]');

  function setBadge(count) {
    if (!badge) return;
    var n = Number(count) || 0;
    if (n > 0) {
      badge.hidden = false;
      badge.textContent = n < 100 ? String(n) : '';
      badge.setAttribute('aria-label', n + ' items in cart');
    } else {
      badge.hidden = true;
      badge.textContent = '';
      badge.removeAttribute('aria-label');
    }
  }

  function syncFromHeaderBubble() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble && bubble.textContent) {
      setBadge(parseInt(bubble.textContent, 10));
      return;
    }
    if (!document.querySelector('#cart-icon-bubble .cart-count-bubble')) {
      setBadge(0);
    }
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var opener = document.querySelector('[data-snt-mobile-search-open]');
      if (opener) {
        opener.click();
        return;
      }
      window.location.href = searchBtn.getAttribute('data-search-url') || '/search';
    });
  }

  if (cartBtn) {
    cartBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      var cartLink = document.querySelector('#cart-icon-bubble');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(cartLink || cartBtn);
        return;
      }
      if (cartLink) {
        cartLink.click();
        return;
      }
      window.location.href = cartBtn.getAttribute('data-cart-url') || '/cart';
    });
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      setBadge(cart.item_count);
      return;
    }
    syncFromHeaderBubble();
  });

  document.addEventListener('cart:refresh', syncFromHeaderBubble);

  var headerCart = document.querySelector('#cart-icon-bubble');
  if (headerCart && window.MutationObserver) {
    var observer = new MutationObserver(syncFromHeaderBubble);
    observer.observe(headerCart, { childList: true, subtree: true, characterData: true });
  }

  syncFromHeaderBubble();
})();
